import {
  Accordion,
  Badge,
  Button,
  ButtonGroup,
  Col,
  Container,
  Form,
  Image,
  InputGroup,
  ListGroup,
  Modal,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
  Row,
  Stack,
} from 'react-bootstrap';
import { Dropdown, Label, Button as Btn, Icon, Popup, Grid, List, ListItem, Image as Img, Placeholder, Form as FormSuir, Input as InputSuir } from 'semantic-ui-react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Fragment, useEffect, useState } from 'react';
import Login from './Login';
import axios from 'axios';
import queryString from 'query-string';
import Signup from './Signup';
import { useNavigate } from 'react-router-dom';
import { useMyGlobal } from './GlobalData';
import { Toast } from './Toast';
import RudLogo from '../assets/rudrunner_logo_white.png'
import RudLogoPhone from '../assets/rudrunner_logo_tosca_black.png'
import { accentColor } from './utility';
import slugify from 'slugify';
import modalPromoImage from '../assets/promo-image.png'
import moment from 'moment';

const NavTop = ({ cart, notif, updateNotif, setCart }) => {
  const ses = window.localStorage
  const navigate = useNavigate()
  const [showLoginModal, setShowLoginModal] = useState(false)
  const [showSignupModal, setShowSignupModal] = useState(false)
  const [login, setLogin] = useState(null)
  const modalLoginClose = () => (setShowLoginModal(false))
  const modalLoginShow = () => {
    setShowLoginModal(true)
    setShowCanvas(false)
  }
  const modalSignupClose = () => (setShowSignupModal(false))
  const modalSignupShow = () => {
    setShowSignupModal(true)
    setShowCanvas(false)
  }
  const [parentCat, setParentCat] = useState([])
  // const [categoryNav, setCategoryNav] = useState([])
  const [defaultCategory, setDefaultCategory] = useState(null)
  const [searchVal, setSearchVal] = useState('')
  const [filteredProduct, setFilteredProduct] = useState([])
  const idCustomer = (ses.getItem('loginDataRr')) ? JSON.parse(ses.getItem('loginDataRr')).id : null
  const [clear, setClear] = useState(false)
  const loginDataRr = localStorage.getItem('loginDataRr')
  const { token, categoryDataNav, categoryData, isPortrait, windowWidth } = useMyGlobal()
  const [showCanvas, setShowCanvas] = useState(false);
  const [modalPromo, setModalPromo] = useState(false);

  const closeModalPromo = () => (setModalPromo(false))
  const showModalPromo = () => (setModalPromo(true))
  const curYear = moment().format('yyyy')
  // const [notif, setNotif] = useState([])
  const location = useLocation()

  const [showSearch, setShowSearch] = useState(false)
  const [popularSearch, setPopularSearch] = useState([])

  const handleLogout = () => {
    ses.removeItem('loginDataRr')
    ses.removeItem('id_cart')
    ses.removeItem('address')
    Toast.fire({
      icon: 'success',
      title: 'Sign out successfully', 
      position: 'center',
      timer: null,
      timerProgressBar: false,
      showConfirmButton: false,
      showCloseButton: true
    })
    setLogin(null)
    navigate('/')
    setShowCanvas(false)
  }

  const getData = async () => {
    const reqBody = queryString.parse('first_name=Hallo&last_name=World&gender=F&dob=2010-12-30&avatar=')

    await axios({
      method: 'POST',
      url: `${global.SRV}api_rudrunner/controler/customer.php/?index=2`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': token
      },
      data: reqBody
    })
      .then((response) => {

      });
  }

  const handleClickCart = () => {
    if (login !== null) {
      if (cart.is_ordered == 0 || !cart.is_ordered) {
        navigate('/cart')
      } else if (cart.is_ordered == 1) {
        alert('There`s pending order')
        navigate('/cart/checkout')
      } else if (cart.is_ordered == 2) {
        alert('There`s pending payment')
        navigate('/cart/checkout/payment')
      } else if (cart.is_ordered == 3) {
        alert('There`s pending snap payment')
        navigate('/cart/checkout/paymentSnap')
      }
    } else {
      Toast.fire({
        icon: "warning",
        text: "You have to register first, before you can shop, if you already have an account, please log in to start shopping",
        position: 'center',
        timer: null,
        timerProgressBar: false,
        showConfirmButton: false,
        showCloseButton: true
      })
    }
  }

  const getCategoryParent = async () => {
    const param = new URLSearchParams()

    param.append('option', 'root')

    await axios({
      method: "POST",
      url: "https://hoopsdevteam.com/api_web/controler/category_rr.php/?index=1",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': token
      },
      data: param
    })
      .then((response) => {
        if (response.data.state === 200) {
          setParentCat(response.data.data)
        }
      })
  }

  // const getCatParentChild = async () => {
  //   const param = new URLSearchParams()
  //   param.append('option', 'parentChild')

  //   await axios({
  //     method: "POST",
  //     url: "https://hoopsdevteam.com/api_web/controler/category.php/?index=1",
  //     headers: {
  //       'Content-Type': 'application/x-www-form-urlencoded',
  //       'authorization': token
  //     },
  //     data: param
  //   })
  //     .then((response) => {
  //       if (response.data.state === 200) {
  //         setCategoryNav(response.data.data.filter(i => i.on_navigation == 1))
  //       }
  //     })
  // }


  const getDefaultCategory = async (sVal) => {
    const param = new URLSearchParams()
    param.append('option', 'defaultCat')
    setShowCanvas(false)

    await axios({
      method: "POST",
      url: "https://hoopsdevteam.com/api_web/controler/category_rr.php/?index=1",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': token
      },
      data: param
    })
      .then(response => {
        let data = {}
        if (response.data.state === 200) {
          data = response.data.data
          data.from = 'parent'
          data.selected_child = 0
          data.search_value = sVal
          setDefaultCategory(data)
          const slug = slugify(data.category_name)
          {/* 
          navigate(
            `/product_list/${data.id_category}/${data.id_category == '6' ? 'product search' : slug}`,
            { state: data }
          )
          */}
           navigate(
            `/product_list/${data.id_category}/${data.id_category == '13' ? 'search' : slug}?product=${encodeURIComponent(sVal)}`,
            { state: data }
          )
        }
      })
  }


  const handleClickNotif = (id_notif, id_customer, date) => {
    const param = new URLSearchParams()

    param.append('id_notif', id_notif)
    param.append('id_customer', id_customer)

    navigate('/customer/notificationPage', { state: { id: id_notif, id_customer: id_customer, date_create: date, id_order: cart.summary.order_id } })


    axios({
      method: "POST",
      url: `${global.SRV}api_rudrunner/controler/notification.php/?index=2&id_customer=${id_customer}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': token
      },
      data: param
    })
      .then(response => {
        if (response.data.state === 200) {
          updateNotif(id_customer)
        }
      })
  }

  const getProductList = async (id_category, id_customer, option, sVal) => {
    const param = new URLSearchParams()
    if (id_customer === null) { id_customer = false }

    param.append('id_category', id_category)
    param.append('id_customer', id_customer)
    param.append('option', option)

    await axios({
      method: "POST",
      url: "https://hoopsdevteam.com/api_web/controler/product_rr_new.php?index=1",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': token
      },
      data: param
    })
      .then(response => {
        let data
        let filtered = []
        if (response.data.state === 200) {
          data = response.data.data
          filtered = data.filter(i => i.product_name.toString().toLowerCase().match(sVal))
          setFilteredProduct(filtered)
        }
      })
  }

  const handleChangeSearch = (e) => {
    setSearchVal(e.target.value)
    if (e.target.value === '') {
      navigate('/')
    }
  }

  const handleChangeSearchMobile = (e) => {
    setSearchVal(e.target.value)
    if (e.target.value === '') {
      navigate('/')
    }
  }

  const handleCloseCanvas = () => { setShowCanvas(false) }
  const handleShowCanvas = () => { setShowCanvas(true) }

  const handleClickProfile = () => {
    setShowCanvas(false)
    navigate('/customer/profile')
  }

  const handleClickSale = () => {
    navigate("/product/discountedProductPage")
    setShowCanvas(false)
  }

  const handleClickBrand = (data) => {
    setShowCanvas(false)
    let par = data
    par.from = 'parent'
    par.selected_child = 0
    const slug = slugify(par.category_name)
    navigate(`/product_list/${data.id_category}/${slug}`, { state: par })
  }

  const handleClickChild = (parent, childId) => {
    setShowCanvas(false)
    let data = parent
    const category_name = parent.hasOwnProperty('child') ? parent.child.find(i => i.id_category_child == childId).category_name : parent.category_name
    data.from = 'child'
    data.selected_child = childId
    const slug = slugify(category_name)
    navigate(`/product_list/${childId}/${slug}`, { state: data })
  }

  useEffect(() => {
    setLogin(JSON.parse(ses.getItem('loginDataRr')))
    getCategoryParent()
    // getCatParentChild()
    // getDefaultCategory(searchVal)
  }, [])

  
  useEffect(() => {
      const params = new URLSearchParams(location.search)
      const searchFromUrl = params.get('product')

      if (searchFromUrl && searchFromUrl !== searchVal) {
          setSearchVal(searchFromUrl)
          getDefaultCategory(searchFromUrl)
      }
  }, [location.search])


  const handleClickClearance = () => {
    navigate("/clearance")
    setShowCanvas(false)
  }
  
  const handleClickBlog = () => {
    navigate("/blog")
    setShowCanvas(false)
  }

  
  const [activeMenu, setActiveMenu] = useState(null);

  const DEFAULT_HEADER_IMAGE =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAB4AAAAEsCAIAAACtzjk+AAAcQElEQVR4nO3d2Vob17qo4VIHCEmIHoRpbOImmfd/GTldeZIYN7QG0YpGINTtA63Nrl2ALJoxg+P3PVqqlErlqnXg5/OY/0j9/vvvEQAAAAAAPLf0P30DAAAAAAD8OwnQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAEIUADAAAAABCEAA0AAAAAQBACNAAAAAAAQQjQAAAAAAAE8X8A9YsVB090ZigAAAAASUVORK5CYII=";

  const getPopularKeyword = async () => {
      try {
          const response = await axios.get(
              `https://rudrunner.co.id/api_rudrunner/controler/popular-keyword.php`
          );

          if (response.data.state === 200) {
              setPopularSearch(response.data.data);
          }
      } catch (err) {
          console.error(err);
      }
  };
  
  const clickPopularKeyword = async (keyword) => {
    try {
        await axios.post(
            'https://rudrunner.co.id/api_rudrunner/controler/popular-keyword.php',
            {
                keyword: keyword
            }
        )
    } catch (err) {
        console.error(err)
    }
  }

  return (
    <>
      <Modal show={showLoginModal} onHide={modalLoginClose} backdrop='static' centered>
        <Modal.Header closeButton>
          <Modal.Title>Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Login
            setShowModal={setShowLoginModal}
            setLogin={setLogin}
            setCart={setCart}
          />

        </Modal.Body>
      </Modal>

      <Modal show={modalPromo} keyboard={false} onHide={closeModalPromo} centered size='lg'>
        <Modal.Body className='p-0 m-0'>
            <Image src={modalPromoImage} fluid rounded style={{ cursor: 'pointer' }} />
        </Modal.Body>
      </Modal>

      <Modal show={showSignupModal} onHide={modalSignupClose} backdrop='static' centered>
        <Modal.Header closeButton>
          <Modal.Title>Signup</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Signup
            setShowModal={setShowSignupModal}
          />
        </Modal.Body>
      </Modal>
      {
        windowWidth > 1000 && !isPortrait ?
          <>
          {/* Top Bar */}
          <div 
            className="topbar fixed-top"
            style={{background:'#00aaad'}}
          >
              <Container fluid="fluid" style={{padding: "0px 25px 0px 25px", marginTop: "15px"}}>
                  <div className="topbar-links d-flex justify-content-end">
                  {/*
                  <Link to="/size-guide" className="topbar-link fw-bold">Size Guide</Link>
                  */}
                  {login === null && 
                    <>
                      <Link onClick={modalSignupShow} className="topbar-link fw-bold" style={{ color: "white" }}>Sign Up</Link>
                      <Link onClick={modalLoginShow} className="topbar-link fw-bold" style={{ color: "white" }}>Sign In</Link>
                    </>
                  }
                  {login !== null && 
                    <>
                      <Link
                        to=""
                        onClick={() => handleLogout()}
                        className="topbar-link fw-bold"
                        style={{ cursor: 'pointer', color: "white" }}
                      >
                        <Icon name="power" className="me-1" />
                        Logout
                      </Link>
                      <Link
                        to="/customer/profile"
                        className="topbar-link fw-bold"
                        style={{ cursor: 'pointer', color: "white" }}
                      >
                        <Icon name="user" className="me-1" />
                        Account
                      </Link>
                      {/*
                      <button
                        onClick={handleLogout}
                        className="topbar-link fw-bold"
                        style={{ cursor: 'pointer', background: 'none', border: 'none', padding: 0 }}
                      >
                        <Icon name="log out" className="me-1" />
                        Logout
                      </button>
                       */}
                    </>
                  }
                  
                  </div>
              </Container>
          </div>

          {/* Main Navbar */}
          <Navbar 
            expand='lg' 
            className="fixed-top is-navbar main-navbar shadow-sm menu-underline"
            onMouseLeave={() => setActiveMenu(null)}
            style={{background:'#00aaad'}}
          >
            <Container fluid="fluid">

              {/* ===== LOGO ===== */}
              <Navbar.Brand style ={{margin: "-1.5em 0px 0.5em 2em" }}>
                <Link to={{ pathname: '/' }}>
                  <div

                  >
                    <Image
                      src={RudLogo}
                      className='zoom'
                      height={50}
                    />
                  </div>
                </Link>
              </Navbar.Brand>

              <Navbar.Toggle aria-controls="basic-navbar-nav" />

              <Navbar.Collapse>
                <Row className="w-100 align-items-center">

                  {/* spacer logo (desktop) */}
                  <Col lg={3} className="d-none d-lg-flex" />

                  {/* ===== MENU TENGAH ===== */}
                  <Col lg={5}>
                    <Nav className="mx-auto fw-bold justify-content-center">

                      {categoryDataNav.length > 0 ? (
                        categoryDataNav.map((parent, i) => {
                          if (parent.category_name === 'HOME') return null;

                          /* ===== MENU DENGAN CHILD ===== */
                          if (parent.child.length > 0) {
                            return (
                              <NavDropdown
                                key={i}
                                title={parent.category_name}
                                className="mega-menu main"
                                show={activeMenu === parent.category_name}
                                onMouseEnter={() => setActiveMenu(parent.category_name)}
                              >
                                <div
                                  className="mega-menu-content"
                                  onMouseEnter={() => setActiveMenu(parent.category_name)}
                                  onMouseLeave={() => setActiveMenu(null)}
                                >
                                  <Row className="justify-content-center gy-4 gx-3">
                                    {parent.child.map((child, x) => (
                                      <Col md={2} key={x} className="d-flex zoom">
                                        <NavDropdown.Item
                                          className="w-100"
                                          onClick={() =>
                                            handleClickChild(parent, child.id_category_child)
                                          }
                                        >
                                          <h6 className="fw-bold" style={{color: "white"}}>
                                            {child.category_name}
                                          </h6>
                                          {/*
                                          <Image
                                            src={`https://picsum.photos/seed/${child.id_category_child}/120/50`}
                                            className="category-thumb zoom"
                                          />
                                          */}
                                          {/*
                                          <Image
                                            src={
                                              child.thumbnail_image
                                                ? child.thumbnail_image
                                                : DEFAULT_HEADER_IMAGE
                                            }
                                            className="category-thumb"
                                          />
                                          */}
                                          <div className="category-thumb-wrapper">
                                            <Image
                                              src={
                                                child.thumbnail_image
                                                  ? child.thumbnail_image
                                                  : DEFAULT_HEADER_IMAGE
                                              }
                                              className="category-thumb"
                                            />
                                          </div>
                                        </NavDropdown.Item>
                                      </Col>
                                    ))}
                                  </Row>
                                  {/*
                                  <Row>
                                    {parent.child.map((child, x) => (
                                      <Col md={2} key={x}>
                                        <NavDropdown.Item
                                          onClick={() =>
                                            handleClickChild(parent, child.id_category_child)
                                          }
                                        >
                                          <h6 className="fw-bold">{child.category_name}</h6>
                                          <Image
                                            src={dummyCategoryHeader}
                                            className="category-thumb zoom"
                                            fluid
                                          />
                                          <Image src={dummyCategoryHeader} height={150} className="zoom" />
                                          
                                        </NavDropdown.Item>
                                      </Col>
                                    ))}
                                  </Row>
                                   */}
                                </div>
                              </NavDropdown>
                            );
                          }

                          /* ===== MENU TANPA CHILD ===== */
                          if (parent.category_name === 'SALE') {
                            return (
                              <Nav.Link
                                className='zoom2'
                                key={i}
                                onClick={handleClickSale}
                                style={{
                                      margin: "0px 13px 0px 13px",
                                      alignSelf: "center",
                                      color: 'white',
                                      background: '#942c61',
                                      padding: '2px 8px',
                                      borderRadius: '2px',
                                      fontWeight: '700',
                                      textTransform: 'uppercase',
                                      /*textShadow: ' -1px -1px 0 #ffffffff, 1px -1px 0 #ffffffff, -1px  1px 0 #ffffffff, 1px  1px 0 #ffffffff'*/
                                }}
                                onMouseEnter={() => setActiveMenu(null)}
                                onMouseLeave={() => setActiveMenu(null)}
                              >
                                {parent.category_name}
                              </Nav.Link>
                            );
                          }
                          if (parent.category_name === 'CLEARANCE') {
                            return (
                              <Nav.Link
                                key={i}
                                onClick={handleClickClearance}
                                style={{
                                      margin: "0px 13px 0px 13px",
                                      alignSelf: "center",
                                      color: 'white',
                                      background: '#942c61',
                                      padding: '2px 8px',
                                      borderRadius: '2px',
                                      fontWeight: '700',
                                      textTransform: 'uppercase',
                                      /*textShadow: ' -1px -1px 0 #ffffffff, 1px -1px 0 #ffffffff, -1px  1px 0 #ffffffff, 1px  1px 0 #ffffffff'*/
                                }}
                                onMouseEnter={() => setActiveMenu(null)}
                                onMouseLeave={() => setActiveMenu(null)}
                              >
                                {parent.category_name}
                              </Nav.Link>
                            );
                          }

                          if (parent.id_category === '20') {
                            return (
                              <Nav.Link
                                key={i} 
                                onClick={handleClickBlog}
                                onMouseEnter={() => setActiveMenu(null)}
                                onMouseLeave={() => setActiveMenu(null)}
                              >
                                {parent.category_name}
                              </Nav.Link>
                            );
                          }

                          if (parent.category_name === 'BRAND') {
                            return (
                              <NavDropdown
                                key={i}
                                title="BRAND"
                                className="mega-menu"
                                show={activeMenu === 'BRAND'}
                                onMouseEnter={() => setActiveMenu('BRAND')}
                              >
                                <div
                                  className="mega-menu-content"
                                  onMouseEnter={() => setActiveMenu('BRAND')}
                                  onMouseLeave={() => setActiveMenu(null)}
                                >
                                  <Row className="justify-content-start gy-4 gx-3">
                                    {categoryData.map((item, idx) => (
                                      <Col md={3} key={idx}>
                                        <h6 className="fw-bold">{item.category_name}</h6>

                                        {item.child.length > 0 ? 
                                        /*(
                                          item.child.map((child, c) => (
                                            <NavDropdown.Item
                                              key={c}
                                              onClick={() =>
                                                handleClickChild(child, child.id_category_child)
                                              }
                                            >
                                              <div className="zoom">
                                                {child.category_name}
                                              </div>
                                            </NavDropdown.Item>
                                          ))
                                        )*/
                                        (
                                          [...item.child]
                                          .sort((a, b) => a.position - b.position)
                                          .map((child, c) => (
                                            <NavDropdown.Item
                                              key={c}
                                              onClick={() =>
                                                handleClickChild(child, child.id_category_child)
                                              }
                                            >
                                              <div className="zoom">
                                                {child.category_name}
                                              </div>
                                            </NavDropdown.Item>
                                          ))
                                        ) : (
                                          <NavDropdown.Item
                                            onClick={() => handleClickBrand(item)}
                                          >
                                            <div className="zoom">
                                              View All
                                            </div>
                                          </NavDropdown.Item>
                                        )}
                                      </Col>
                                    ))}
                                  </Row>
                                </div>
                              </NavDropdown>
                            );
                          }

                          return (
                            <Nav.Link key={i}>{parent.category_name}</Nav.Link>
                          );
                        })
                      ) : 
                      
                      <>
                        {Array.from({ length: 7 }).map((_, i) => (
                          <span key={i} className="me-2">
                            <Placeholder style={{ width: '5rem' }}>&nbsp;</Placeholder>
                          </span>
                        ))}
                      </>
                      
                      }

                    </Nav>
                  </Col>

                  <Col lg={4} className="d-lg-flex justify-content-end align-items-center gap-1">

                    {/* ===== SEARCH / ACTION ===== */}
                    {location.pathname !== "/clearance" && (
                      <Nav className='ms-9 text-end' style={{width: '45%'}}>
                        <FormSuir onSubmit={(e) => getDefaultCategory(searchVal)}>
                          <Popup trigger={
                            <InputSuir
                              // style={{background: '#d63384!', border:'2px solid white',borderRadius: '5px'}}
                              value={searchVal}
                              onChange={(e) => handleChangeSearch(e)}
                              icon={{ onClick: (e) => getDefaultCategory(searchVal), name: "search", link: true }}
                              placeholder="Search"
                            />}
                            content="Type Name or Article and then press Enter"
                          />
                        </FormSuir>
                      </Nav>
                    )}

                    {login !== null &&
                      <>
                        <Nav className="ms-1">
                          <Nav.Item>
                            <Popup trigger={
                              <div onClick={() => handleClickCart()}>
                              <Icon name='cart' className={cart.products.length > 0 ? 'border-pulse-color' : ''} style={{color: "white"}} size='large' />
                              <Label circular size='tiny' 
                              style={{ 
                                backgroundColor: '#942c61',
                                color: 'white',
                                position: 'absolute', 
                                zIndex: 1, 
                                marginLeft: '-1em', 
                                top: '0.9em' 
                              }}>
                                {
                                  cart && cart.is_ordered !== 2
                                    ? Object.values(
                                        cart.products.reduce((acc, item) => {
                                          const key = `${item.product_id}_${item.selected_size}_${item.selected_color?.id || ''}`;
                                          acc[key] = (acc[key] || 0) + item.qty;
                                          return acc;
                                        }, {})
                                      ).reduce((total, qty) => total + qty, 0)
                                    : 0
                                }
                              </Label>
                              </div>
                              }
                                flowing
                                hoverable
                              >
                                {(cart.products.length > 0 ? (
                                  Object.values(
                                    cart.products.reduce((acc, item) => {
                                      const key = `${item.product_id}_${item.selected_size}_${item.selected_color?.id || ''}`;
                                      if (!acc[key]) {
                                        acc[key] = { ...item };
                                      } else {
                                        acc[key].qty += item.qty;
                                      }
                                      return acc;
                                    }, {})
                                  ).map((item, i) => (
                                    <Fragment key={i}>
                                      <Stack direction="horizontal" gap={2} className="mb-3">
                                        <Image
                                          src={item.product_image ? item.product_image.image : 'https://via.placeholder.com/500x400.png'}
                                          width={60}
                                          height={52}
                                          rounded
                                        />
                                        <Stack direction="vertical" gap={0}>
                                          <small className="fw-bold">
                                            {item.product_name} (x{item.qty})
                                          </small>
                                          <small>{global.IDR.format(item.final_price)}</small>
                                          <small>
                                            <span className="me-3">Size : {item.selected_size}</span>
                                            <span>
                                              Color : &nbsp;
                                              {item.selected_color ? (
                                                <>
                                                  <canvas
                                                    className="border-start border-top border-bottom border-dark"
                                                    width={10}
                                                    height={10}
                                                    style={{ backgroundColor: item.selected_color.color_main }}
                                                  />
                                                  <canvas
                                                    className="border-top border-bottom border-dark"
                                                    width={10}
                                                    height={10}
                                                    style={{ backgroundColor: item.selected_color.color_secondary }}
                                                  />
                                                  <canvas
                                                    className="border-end border-top border-bottom border-dark"
                                                    width={10}
                                                    height={10}
                                                    style={{ backgroundColor: item.selected_color.color_accent }}
                                                  />
                                                </>
                                              ) : null}
                                            </span>
                                          </small>
                                        </Stack>
                                      </Stack>
                                    </Fragment>
                                  ))
                                ) : (
                                  <div className="text-muted">Cart is empty</div>
                                ))}
                              </Popup>

                          </Nav.Item>
                        </Nav>

                        <Nav className="ms-1">
                          <Nav.Item>
                            {/*
                            <Label color='orange' circular size='tiny' style={{ position: 'absolute', zIndex: 1, marginLeft: '2.7em', marginTop: '-0.8em' }}>{Array.isArray(notif) ? notif.length : 0}</Label>
                            */}
                            <Label
                              circular
                              size='tiny'
                              style={{
                                backgroundColor: '#942c61',
                                color: 'white',
                                position: 'absolute',
                                zIndex: 1,
                                marginLeft: '1.5em',
                                marginTop: '-1.2em'
                              }}
                            >
                              {Array.isArray(notif) ? notif.length : 0}
                            </Label>
                            <Dropdown
                              basic
                              className='icon'
                              icon="bell"
                              floating
                              labeled
                              style={{
                                borderRadius: 3,
                                color: 'white',
                                //border: '2px solid white',
                                paddingLeft: 0, paddingRight: 15,
                                fontSize: '1.6em',
                                paddingTop: 5,
                                paddingBottom: 0
                              }}
                            >
                              <Dropdown.Menu style={{ height: '60vh', overflowY: 'auto', transform: 'translate(-55%, 2%)' }}>
                                <Dropdown.Header icon='bell outline' content='Notification'  style={{ fontSize: 12  }}/>
                                <Dropdown.Divider />
                                {
                                  notif.length > 0 && Array.isArray(notif) ?
                                    notif.map((item, i) => (
                                      <section key={i}>
                                        <Dropdown.Item className='p-3 notif' style={{ cursor: 'pointer', color:'black' }}
                                          onClick={() => handleClickNotif(item.id, item.id_customer, item.date_create)}
                                        >
                                          <div key={i}>
                                            <Stack direction='vertical' gap={1}>
                                              <Stack direction='horizontal' gap={1}>
                                                <Icon name='envelope' style={{ fontSize: 15 }} />
                                                <div className='fw-bold' style={{ fontSize: 15 }}>{item.label}</div>
                                              </Stack>
                                              <div style={{ maxWidth: '200px', whiteSpace: 'pre-wrap', fontSize: 15  }}><p className='text-truncate'>{item.description}</p></div>
                                              <div className='text-muted' style={{ fontSize: 10 }}>{item.date_create}</div>
                                            </Stack>
                                          </div>
                                        </Dropdown.Item>
                                      </section>
                                    ))
                                    :
                                    <Dropdown.Item>No new notification</Dropdown.Item>
                                }
                                {/* <Dropdown.Item
                                label={{ color: 'red', empty: true, circular: true }}
                                text='Important'
                              />
                              <Dropdown.Item
                                label={{ color: 'blue', empty: true, circular: true }}
                                text='Announcement'
                              />
                              <Dropdown.Item
                                label={{ color: 'black', empty: true, circular: true }}
                                text='Discussion'
                              /> */}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Nav.Item>
                        </Nav>
                      </>
                    }

                  </Col>
                </Row>
              </Navbar.Collapse>
            </Container>
          </Navbar >
          </>
          :
          <>
            
            <Row className='is-navbar p-3 fixed-top' 
              style={{
                  height: '74px',
                  position: 'fixed',
                  top: 0,
                  left: "10px",
                  right: "10px",
                  zIndex: 1030,
                  background: "#00aaad"
              }}
            >
              <Col xs={5} sm={5} className='d-flex align-items-center justify-content-start'>
                <Icon name='sidebar' onClick={handleShowCanvas} size='large' style={{cursor: "pointer", color: "white"}}/>
                {location.pathname !== "/clearance" && (
                    <Icon
                      className='ms-3'
                      name='search'
                      size='large'
                      onClick={(e) => {
                          e.preventDefault()

                          setShowSearch(true)
                          getPopularKeyword()
                      }}
                      style={{ cursor: 'pointer', color: "white"}}
                    />
                )}
              </Col>

              <Col xs={2} sm={2} className='d-flex align-items-center justify-content-center'>
                <Image src={RudLogo} height="40" width="40" className=' zoom' onClick={() => navigate('/')} style={{cursor: "pointer"}} />
              </Col>

              <Col xs={5} sm={5} className='d-flex align-items-center justify-content-end'>
                <Stack direction='horizontal' gap={3}>
                  <div>
                    <div onClick={() => handleClickCart()} style={{cursor: "pointer"}}>
                      <Icon name='cart' className={cart.products.length > 0 ? 'border-pulse-color' : ''} style={{color: "white"}} size='large' />
                      <Label circular size='tiny' 
                      style={{ position: 'absolute', 
                        zIndex: 1, 
                        marginLeft: '-1em', 
                        top: '0.9em',
                        backgroundColor: "#942c61", 
                        color: "white" }}>
                        {
                          cart && cart.is_ordered !== 2
                            ? Object.values(
                                cart.products.reduce((acc, item) => {
                                  const key = `${item.product_id}_${item.selected_size}_${item.selected_color?.id || ''}`;
                                  acc[key] = (acc[key] || 0) + item.qty;
                                  return acc;
                                }, {})
                              ).reduce((total, qty) => total + qty, 0)
                            : 0
                        }
                      </Label>
                    </div>
                  </div>
                  {login !== null &&
                  <div>
                    <Label circular size='tiny' 
                      style={{ position: 'absolute', 
                      zIndex: 1, 
                      marginLeft: '1.2em', 
                      top: '0.9em', 
                      backgroundColor: "#942c61", 
                      color: "white" }}>
                      {Array.isArray(notif) ? notif.length : 0}</Label>
                    <Dropdown
                      basic
                      className='icon'
                      icon={<Icon name='bell' size='large' />}
                      style={{color: "white"}}
                      floating
                      labeled
                    >
                      <Dropdown.Menu style={{ height: '60vh', overflowY: 'auto', transform: 'translateX(-80%)'}}>
                        <Dropdown.Header icon='bell outline' content='Notification' />
                        <Dropdown.Divider />
                        {
                          notif.length > 0 && Array.isArray(notif) ?
                            notif.map((item, i) => (
                              <section key={i}>
                                <Dropdown.Item className='p-3 notif' style={{ cursor: 'pointer' }}
                                  onClick={() => handleClickNotif(item.id, item.id_customer, item.date_create)}
                                >
                                  <div key={i}>
                                    <Stack direction='vertical' gap={1}>
                                      <Stack direction='horizontal' gap={1}>
                                        <Icon style={{color: '#444444'}} name='envelope' />
                                        <div style={{color: '#444444'}} className='fw-bold'>{item.label}</div>
                                      </Stack>
                                      <div style={{ maxWidth: '200px', whiteSpace: 'pre-wrap', color: '#444444'}}><p className='text-truncate'>{item.description}</p></div>
                                      <div className='text-muted' style={{ fontSize: 10 }}>{item.date_create}</div>
                                    </Stack>
                                  </div>
                                </Dropdown.Item>
                              </section>
                            ))
                            :
                            <Dropdown.Item>No new notification</Dropdown.Item>
                        }
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  }
                </Stack>
              </Col>

            </Row>
            <Offcanvas show={showCanvas} onHide={handleCloseCanvas}>
              <Offcanvas.Header style={{padding : "30px 30px 10px 30px"}} closeButton>
                <Offcanvas.Title>
                  {
                    (login !== null) ?
                      <Stack direction='horizontal' gap={4}>
                        <Image src={
                          JSON.parse(localStorage.getItem("loginDataRr")).profile.avatar != '' ?
                            JSON.parse(localStorage.getItem("loginDataRr")).profile.avatar :
                            `https://ui-avatars.com/api/?name=${JSON.parse(localStorage.getItem("loginDataRr")).profile.first_name}+${JSON.parse(localStorage.getItem("loginDataRr")).profile.last_name}`} height={75} width={75} roundedCircle className='border p-1' />
                        <Stack direction='vertical' gap={0}>
                          <div style={{ fontSize: '1.3rem', fontWeight: '500'}}>Hello,</div>
                          <div style={{ fontSize: '1.5rem', fontWeight: '800' }}>{JSON.parse(localStorage.getItem("loginDataRr")).profile.first_name}</div>
                          <Btn.Group size='mini'>
                            <Btn  style={{backgroundColor : "#00aaad", color : "white"}} content="Logout" icon="logout" onClick={() => handleLogout()} size="mini" />
                            <Btn  style={{backgroundColor : "#00aaad", color : "white"}} content="Profile" icon="user" onClick={() => handleClickProfile()} />
                          </Btn.Group>
                        </Stack>
                      </Stack>
                      :
                    (
                      <Link to="/">
                        <Image src={RudLogoPhone} height={40} className="zoom" />
                      </Link>
                    )
                      
                  }
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Accordion className="border-0 mobile-menu-accordion">
                  {
                    categoryDataNav.length > 0 ?
                      categoryDataNav.map((parent, i) => {
                        return (
                          (parent.category_name !== 'HOME') ?
                            <Accordion.Item eventKey={i} className="border-0 border-none">
                              {
                                parent.category_name == 'SALE' ?
                                <>
                                  <Accordion.Item className="border-0 menu-title-mobile" style={{ padding: '12px 10px 12px 16px', border: 'none', color: '#00aaad' }} onClick={handleClickSale}>SALE</Accordion.Item>
                                </>
                                :
                                parent.category_name == 'CLEARANCE' ?
                                <>
                                  <Accordion.Item className="border-0 menu-title-mobile" style={{ padding: '12px 10px 12px 16px', border: 'none', color: '#00aaad' }} onClick={handleClickClearance}>CLEARANCE</Accordion.Item>
                                </>
                                :
                                parent.category_name == 'BRAND' ?
                                <>
                                  <Accordion.Header >{parent.category_name}</Accordion.Header>
                                  <Accordion.Body>
                                    <Accordion className="border-0 mobile-menu-accordion-brand" style={{ borderWidth: 0 }}>
                                      {
                                        categoryData.map((parent, n) => (
                                          parent.child.length > 0 ?
                                            <Accordion.Item eventKey={n} className="border-0">
                                              <Accordion.Header action key={n}>{parent.category_name}</Accordion.Header>
                                              <Accordion.Body>
                                                <ListGroup variant='flush'>
                                                  {
                                                    parent.child.map((child, c) => (
                                                      <ListGroup.Item 
                                                        className="border-0" 
                                                        key={c} onClick={() => handleClickBrand(child)}
                                                      >
                                                        <button className="blank-button w-100 text-start">
                                                          <div className="zoom p-0 m-0 border-0">
                                                            {child.category_name}
                                                          </div>
                                                        </button>
                                                      </ListGroup.Item>
                                                    ))
                                                  }
                                                </ListGroup>
                                              </Accordion.Body>
                                            </Accordion.Item>
                                            :
                                              <Accordion.Item
                                                className="border-0"
                                                style={{ padding: '14px 17.5px', fontSize: '1.2rem' }}
                                                onClick={() => handleClickBrand(parent)}
                                              >
                                                <button className="blank-button w-100 text-start">
                                                  {parent.category_name}
                                                </button>
                                              </Accordion.Item>
                                        ))
                                      }
                                    </Accordion>
                                  </Accordion.Body>
                                </>
                                :
                                parent.id_category == '20' ?
                                <>
                                  <Accordion.Item className="menu-title-mobile" style={{ padding: '12px 10px 12px 16px', border: 'none' }} onClick={handleClickBlog}>{parent.category_name}</Accordion.Item>
                                </>
                                :
                                <>
                                  <Accordion.Header >{parent.category_name}</Accordion.Header>
                                  <Accordion.Body>
                                    <ListGroup variant='flush'>
                                      {
                                        parent.child.length > 0 ?
                                          parent.child.map((child, x) => {
                                            return (
                                              <ListGroup.Item
                                                className="border-0" 
                                                action
                                                key={x}
                                                onClick={() => handleClickChild(parent, child.id_category_child)}
                                              >
                                                <button className="blank-button w-100 text-start">
                                                  <div className="zoom p-0 m-0 border-0">
                                                    {child.category_name}
                                                  </div>
                                                </button>
                                              </ListGroup.Item>
                                            )
                                          })
                                          :
                                          <></>
                                      }
                                    </ListGroup>
                                  </Accordion.Body>
                                </>
                              }
                            </Accordion.Item>
                            : <></>
                          // <Accordion.Item eventKey={i}>
                          //   <Accordion.Header>{parent.category_name}</Accordion.Header>
                          //   <Accordion.Body>
                          //     {parent.category_name}
                          //   </Accordion.Body>
                          // </Accordion.Item>
                        )
                      })
                      :
                      <>Loading...</>
                  }
                </Accordion>

                {
                  login === null ?
                    <div className='mt-5'>
                      <Btn.Group fluid>
                        <Btn content='Login' onClick={modalLoginShow} color="black" />
                        <Btn.Or />
                        <Btn content='Sign up' onClick={modalSignupShow} color="grey" />
                      </Btn.Group>
                    </div>

                    : <></>
                }
                <div className='d-flex justify-content-center' style={{ position: 'absolute', bottom: '20px', width: '100%' }}>
                  <p>&copy; {curYear}. <span style={{ color: '#00aaad' }}>JFS Developer.</span></p>
                </div>
              </Offcanvas.Body>
            </Offcanvas>

<Offcanvas
    show={showSearch}
    onHide={() => setShowSearch(false)}
    placement='top'
    className='search-offcanvas'
    style={{
        height: popularSearch.length ? "25em" : "15em",
        background: "#00aaad"
    }}
>
    <Offcanvas.Body className='search-body-offcanvas'>
        {/* LOGO - TENGAH */}
        <div
            className='position-absolute start-50 translate-middle-x'
            style={{ zIndex: 2, top: "30px" }}
        >
            <Image
                src={RudLogo}
                height='40'
                width='40'
                className='zoom'
                onClick={() => navigate('/')}
                style={{ cursor: 'pointer' }}
            />
        </div>
        <div className='d-flex align-items-center gap-2'>

            <Icon
                name='search'
                size='large'
                style={{color: "white"}}
            />

            <FormSuir
                className='flex-grow-1'
                onSubmit={(e) => {
                    e.preventDefault()

                    getDefaultCategory(searchVal)
                    setShowSearch(false)
                }}
            >
                <InputSuir
                    fluid
                    autoFocus
                    value={searchVal}
                    placeholder='Search product...'
                    type='search'
                    onChange={(e) => handleChangeSearchMobile(e)}
                    transparent
                    className='search-input-white'
                />
            </FormSuir>

            <Icon
                name='close'
                size='large'
                link
                onClick={() => setShowSearch(false)}
                style={{ cursor: 'pointer', color: "white"}}
            />

        </div>

        <hr style={{ color: "white"}}/>

        {popularSearch.length ? (

          <div style={{marginTop : "25px"}}>
              <div className='fw-semibold mb-3'
                  style={{color: "white"}}
              >
                  Most Searched Items
              </div>

              <div className='d-flex flex-wrap gap-2'>
                {popularSearch.map((item, i) => (
                    <span
                        key={i}
                        className='search-keyword fw-semibold'
                        onClick={() => {
                            setSearchVal(item.keyword)
                            getDefaultCategory(item.keyword)
                            setShowSearch(false)
                            clickPopularKeyword(item.keyword)
                        }}
                    >
                        {item.keyword}
                    </span>
                ))}
            </div>
          </div>
        )
          :<></>}
    </Offcanvas.Body>
</Offcanvas>

          </>
      }
    </>
  )
}

export default NavTop;